import React from 'react';
import { Box, Typography, Container, Divider } from '@mui/material';
import LoadingNavBar from '../../components/navbar/LoadingNavBar';
import Footer from '../../components/footer/Footer';
import { useTranslation } from 'react-i18next';
import { StringKeys } from '../../resources/strings/StringKeys';

const ProhibitedBusinesses = () => {
  const { t } = useTranslation();
  
  const colors = {
    background: "#ffffff",
    primary: "#102a43",
    secondary: "#39ace7",
    textPrimary: "#212529",
    textSecondary: "#495057",
  };

  const categories = [
    { title: StringKeys.PROHIBITED_BUSINESSES_ILLEGAL_SECTION, items: StringKeys.PROHIBITED_BUSINESSES_ILLEGAL_ITEMS },
    { title: StringKeys.PROHIBITED_BUSINESSES_REGULATED_SECTION, items: StringKeys.PROHIBITED_BUSINESSES_REGULATED_ITEMS },
    { title: StringKeys.PROHIBITED_BUSINESSES_ADULT_SECTION, items: StringKeys.PROHIBITED_BUSINESSES_ADULT_ITEMS },
    { title: StringKeys.PROHIBITED_BUSINESSES_GAMBLING_SECTION, items: StringKeys.PROHIBITED_BUSINESSES_GAMBLING_ITEMS },
    { title: StringKeys.PROHIBITED_BUSINESSES_FINANCIAL_SECTION, items: StringKeys.PROHIBITED_BUSINESSES_FINANCIAL_ITEMS },
    { title: StringKeys.PROHIBITED_BUSINESSES_IP_SECTION, items: StringKeys.PROHIBITED_BUSINESSES_IP_ITEMS },
    { title: StringKeys.PROHIBITED_BUSINESSES_HARMFUL_SECTION, items: StringKeys.PROHIBITED_BUSINESSES_HARMFUL_ITEMS },
    { title: StringKeys.PROHIBITED_BUSINESSES_HIGH_RISK_SECTION, items: StringKeys.PROHIBITED_BUSINESSES_HIGH_RISK_ITEMS },
    { title: StringKeys.PROHIBITED_BUSINESSES_VIOLENCE_SECTION, items: StringKeys.PROHIBITED_BUSINESSES_VIOLENCE_ITEMS },
    { title: StringKeys.PROHIBITED_BUSINESSES_ONLINE_SECTION, items: StringKeys.PROHIBITED_BUSINESSES_ONLINE_ITEMS },
    { title: StringKeys.PROHIBITED_BUSINESSES_PRIVACY_SECTION, items: StringKeys.PROHIBITED_BUSINESSES_PRIVACY_ITEMS },
    { title: StringKeys.PROHIBITED_BUSINESSES_MONEY_LAUNDERING_SECTION, items: StringKeys.PROHIBITED_BUSINESSES_MONEY_LAUNDERING_ITEMS },
    { title: StringKeys.PROHIBITED_BUSINESSES_UNFAIR_SECTION, items: StringKeys.PROHIBITED_BUSINESSES_UNFAIR_ITEMS },
    { title: StringKeys.PROHIBITED_BUSINESSES_OTHER_SECTION, items: StringKeys.PROHIBITED_BUSINESSES_OTHER_ITEMS },
  ];

  return (
    <>
      <LoadingNavBar showLoginButton={true} />
      <Box
        sx={{
          background: colors.background,
          color: colors.textPrimary,
          minHeight: '100vh',
          py: 15,
          px: { xs: 3, md: 6 },
        }}
      >
        <Container maxWidth="md">
          <Typography variant="h4" gutterBottom sx={{ fontWeight: 'bold', color: colors.primary, textAlign: 'center' }}>
            {t(StringKeys.PROHIBITED_BUSINESSES_TITLE)}
          </Typography>
          <Typography variant="subtitle1" gutterBottom sx={{ textAlign: 'center', color: colors.textSecondary }}>
            {t(StringKeys.PROHIBITED_BUSINESSES_LAST_UPDATED)}
          </Typography>

          <Divider sx={{ my: 4 }} />

          <Typography variant="body1" paragraph>
            {t(StringKeys.PROHIBITED_BUSINESSES_INTRO)}
          </Typography>

          {/* Prohibited Categories */}
          {categories.map((category, index) => (
            <Box key={index} sx={{ mt: 4 }}>
              <Typography variant="h5" sx={{ fontWeight: 'bold', color: colors.primary }}>
                {t(category.title)}
              </Typography>
              <ul>
                {t(category.items, { returnObjects: true }).map((item, idx) => (
                  <li key={idx}>
                    <Typography variant="body1">{item}</Typography>
                  </li>
                ))}
              </ul>
            </Box>
          ))}

          {/* Enforcement Actions */}
          <Typography variant="h5" sx={{ fontWeight: 'bold', color: colors.primary, mt: 4 }}>
            {t(StringKeys.PROHIBITED_BUSINESSES_ENFORCEMENT_SECTION)}
          </Typography>
          <Typography variant="body1" paragraph>
            {t(StringKeys.PROHIBITED_BUSINESSES_ENFORCEMENT_CONTENT)}
          </Typography>

          {/* Responsibilities */}
          <Typography variant="h5" sx={{ fontWeight: 'bold', color: colors.primary, mt: 4 }}>
            {t(StringKeys.PROHIBITED_BUSINESSES_RESPONSIBILITIES_SECTION)}
          </Typography>
          <Typography variant="body1" paragraph>
            {t(StringKeys.PROHIBITED_BUSINESSES_RESPONSIBILITIES_CONTENT)}
          </Typography>
        </Container>
      </Box>
      <Footer />
    </>
  );
};

export default ProhibitedBusinesses;
